// extracted by css-extract-rspack-plugin
export default {"list-wrapper":"nZwr9U","listWrapper":"nZwr9U"};